import { stripeAccountModes } from '../../../utils/constants';

/**
 * @param {string} name
 * @returns {string} full name with firstname and only first letter of family name
 */
export const shortcutName = (name) => {
    if (/\s/.test(name)) {
        return name.slice(0, name.indexOf(' ') + 2) + '.';
    }
};

/**
 * @param {object} am
 * @returns {object} options for account select
 */
export const accountTeamManagerMap = (am) => {
    return {
        value: am.idAccountTeam,
        text: shortcutName(am.displayName),
    };
};

/**
 *
 * @param {string|number} idAccountTeam
 * @param {array} teamMembers
 * @returns {string|null} name of manager
 */
export const getNameIdAccountTeam = (idAccountTeam, teamMembers) => {
    const value = teamMembers.find(
        (tm) => Number(tm.idAccountTeam) === idAccountTeam,
    );
    return value ? value.displayName : null;
};

/**
 * @description to create proper stripe status based on values
 * @param {boolean} readyToOnboard
 * @param {boolean} onboardingCompleted
 * @param {string} validatedAt
 */
export const detectStripeStatus = (
    readyToOnboard,
    onboardingCompleted,
    validatedAt,
) => {
    let stripeStatus = null;

    if (onboardingCompleted) {
        if (validatedAt > 0) {
            stripeStatus = stripeAccountModes.VALIDATED;
        } else {
            stripeStatus = stripeAccountModes.TOVALIDATE;
        }
    } else {
        if (readyToOnboard) {
            stripeStatus = stripeAccountModes.TOCREATE;
        } else {
            stripeStatus = stripeAccountModes.NONE;
        }
    }

    return stripeStatus;
};
